
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { numberWithCommasNull } from "../../../../helpers/numberWithCommas";
const Tokenomics = ({ t }) => {
    const tokenomics = t('home:tokenomics', {}, { returnObjects: true });
    return (<section className={'tokenomics'} id={'tokenomics'}>
            <picture>
                <source srcSet={`/img/pages/home/tokenomics/tokenomics_logo.webp?v=2`} type="image/webp"/>
                <source srcSet={`/img/pages/home/tokenomics/tokenomics_logo.png?v=2`}/>
                <img src={`/img/pages/home/tokenomics/tokenomics_logo.png?v=2`} alt={`PEPE Ecosystem`} width={567} height={490} className='tokenomics_logo_img'/>
            </picture>
            <picture>
                <source srcSet={`/img/pages/home/tokenomics/tokenomics_money.webp?v=2`} type="image/webp"/>
                <source srcSet={`/img/pages/home/tokenomics/tokenomics_money.png?v=2`}/>
                <img src={`/img/pages/home/tokenomics/tokenomics_money.png?v=2`} alt={`PEPE Tokenomics`} width={1519} height={781} className='tokenomics_money_img'/>
            </picture>
            <div className="container">
                <div className="tokenomics_wrapper">

                    <h2 className={'tokenomics_title'}>{tokenomics.title}</h2>
                    <div className={'tokenomics_supply'}>
                        <picture>
                            <source srcSet={`/img/pages/home/tokenomics/ball.webp?v=3`} type="image/webp"/>
                            <source srcSet={`/img/pages/home/tokenomics/ball.png?v=3`}/>
                            <img src={`/img/pages/home/tokenomics/ball.png?v=3`} alt={`PEPE Tokenomics`} width={206} height={220} className='tokenomics_ball_top'/>
                        </picture>
                        <picture>
                            <source srcSet={`/img/pages/home/tokenomics/ball.webp?v=3`} type="image/webp"/>
                            <source srcSet={`/img/pages/home/tokenomics/ball.png?v=3`}/>
                            <img src={`/img/pages/home/tokenomics/ball.png?v=3`} alt={`PEPE Tokenomics`} width={206} height={220} className='tokenomics_ball_bottom'/>
                        </picture>
                        <h3 className={'tokenomics_supply_title'}>{tokenomics.supply_title}</h3>
                        <h4 className={'tokenomics_supply_value'}>{numberWithCommasNull(3695000000)}</h4>
                        <p className={'tokenomics_supply_contract'}>
                            <span>{tokenomics.contract}</span><span>0x8745a1eac4e22454fd5b9386995fae949221042e</span>
                        </p>
                        <p className={'tokenomics_supply_audit'}><span>{tokenomics.audit}</span><a href={'https://coinsult.net/projects/pepe-dollar-2/'} target={'_blank'} rel={'noreferrer noopener'}>Audit</a></p>
                    </div>
                </div>
            </div>
        </section>);
};
export default Tokenomics;

    async function __Next_Translate__getStaticProps__1989dd500f4__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Tokenomics/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd500f4__ as getStaticProps }
  